import { registerPropertyManagerSection, type PropertyManagerContext } from '@/core';
import SmartDimensionPropertySection from '@/components/editor/property-manager/smart-dimension/SmartDimensionPropertySection.vue';

/**
 * 判断是否有草图实体属性面板正在显示（线/圆/弧/椭圆/多边形/矩形/样条/槽口/点）。
 *
 * 说明：尺寸属性段与实体属性段互斥——选中普通草图实体时应显示实体属性，
 * 尺寸选择残留不得把尺寸段叠加/顶替实体段（否则用户改不了实体长度等参数）。
 */
function isSketchEntityPropertyVisible(context: PropertyManagerContext): boolean {
  return context.linePropertyVisible === true
    || context.arcPropertyVisible === true
    || context.circlePropertyVisible === true
    || context.ellipsePropertyVisible === true
    || context.polygonPropertyVisible === true
    || context.rectanglePropertyVisible === true
    || context.splinePropertyVisible === true
    || context.styleSplinePropertyVisible === true
    || context.slotPropertyVisible === true
    || context.pointPropertyVisible === true;
}

registerPropertyManagerSection({
  id: 'sketch-smart-dimension',
  title: '尺寸',
  order: 16,
  component: SmartDimensionPropertySection,
  isApplicable: (context) => context.isSketchActive === true
    && context.sketchDimensionSelection != null
    && !isSketchEntityPropertyVisible(context),
});
